import { render, staticRenderFns } from "./TaxiSettingButton.vue?vue&type=template&id=4e0d445c"
import script from "./TaxiSettingButton.vue?vue&type=script&lang=js"
export * from "./TaxiSettingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports